// ABOUTME: SPEC-82 — every new user-visible string of the voice-first experiment, as data.
// ABOUTME: The brand is a parameter (read from /api/config), never a literal here.

export const talkTo = (brandName) => `Talk to ${brandName || 'us'}`;
// Owner 2026-10-08: between the tap and the agent's first words (the connection and voice session start at the tap).
export const connectingTo = (brandName) => `Connecting to ${brandName || 'us'}…`;
export const VOICE_HINT = 'Voice enabled — speak to explore';
export const HOW_IT_WORKS = 'How it works';

export const ARIA = Object.freeze({
  showControls: 'Show controls',
  hideControls: 'Hide controls',
  typeMessage: 'Type a message',
  hideTextInput: 'Hide text input',
  muteMic: 'Mute microphone',
  unmuteMic: 'Unmute microphone',
  stopAgent: 'Stop the agent',
  sharePhoto: 'Share a photo of your own piece or watch',
  menu: 'Open menu',
  menuClose: 'Close menu',
});
